var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElevatorOffDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11028 7.1374L8.99718 3.25L11.091 5.34404L10.4216 6.03895L8.99718 4.61362L5.79457 7.81871C5.70326 7.91051 5.58119 7.96063 5.45218 7.96063C5.32365 7.96063 5.20307 7.91101 5.11177 7.81971C4.9232 7.63213 4.92271 7.32596 5.11028 7.1374ZM6.11353 10.5118L5.78291 10.1813C5.69111 10.0944 5.57202 10.0503 5.45342 10.0503C5.33334 10.0503 5.21325 10.0949 5.11947 10.1838C5.02618 10.2731 4.97308 10.3927 4.9701 10.5217C4.96713 10.6507 5.01427 10.7728 5.10309 10.8656L5.44419 11.2067L6.11353 10.5118ZM6.20661 11.9691L6.87612 11.274L8.98752 13.3844L12.1926 10.1823C12.3822 9.9952 12.6878 9.99768 12.8744 10.1867C13.0585 10.3733 13.059 10.677 12.8759 10.8631L8.98752 14.75L6.20661 11.9691ZM11.1838 6.80161L11.8533 6.10651L12.8841 7.1374C12.9749 7.22871 13.025 7.34929 13.025 7.4783C13.025 7.60683 12.9749 7.7279 12.8836 7.81921C12.7938 7.90903 12.6687 7.96014 12.5422 7.96014H12.5407C12.4132 7.96014 12.2931 7.91051 12.2018 7.8202L11.1838 6.80161Z",
    fill: "#111"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.46997,
    y: 13.4709,
    width: 13.1418,
    height: 1,
    rx: 0.5,
    transform: "rotate(-46.0777 4.46997 13.4709)",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevatorOffDark);
export default __webpack_public_path__ + "static/media/elevator-off-dark.2f83a1452fba5861c81be0b68f78f426.svg";
export { ForwardRef as ReactComponent };